<template>
  <div class="admin-categories">
    <div class="page-header">
      <h2 class="page-title">分类管理</h2>
      <el-button type="primary" icon="el-icon-plus" @click="showAddDialog">新建分类</el-button>
    </div>

    <el-table :data="categories" v-loading="loading" stripe>
      <el-table-column prop="name" label="名称" />
      <el-table-column prop="slug" label="Slug" />
      <el-table-column prop="description" label="描述" />
      <el-table-column prop="article_count" label="文章数" width="80" />
      <el-table-column prop="sort_order" label="排序" width="60" />
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="showEditDialog(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteCategory(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新建/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" modal="false" close-on-click-modal="false" width="400px">
      <el-form :model="form" label-position="top">
        <el-form-item label="名称">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="Slug">
          <el-input v-model="form.slug" />
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="form.description" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort_order" :min="0" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveCategory">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { adminApi, frontApi } from '../../utils/api'

export default {
  name: 'AdminCategories',
  data() {
    return {
      categories: [],
      loading: false,
      dialogVisible: false,
      isEdit: false,
      editId: null,
      form: { name: '', slug: '', description: '', sort_order: 0 }
    }
  },
  computed: {
    dialogTitle() { return this.isEdit ? '编辑分类' : '新建分类' }
  },
  created() {
    this.loadCategories()
  },
  methods: {
    async loadCategories() {
      this.loading = true
      try {
        const res = await frontApi.getCategories()
        this.categories = res.categories || []
      } catch (e) { console.error(e) }
      this.loading = false
    },
    showAddDialog() {
      this.isEdit = false
      this.form = { name: '', slug: '', description: '', sort_order: 0 }
      this.dialogVisible = true
    },
    showEditDialog(row) {
      this.isEdit = true
      this.editId = row.id
      this.form = { name: row.name, slug: row.slug, description: row.description, sort_order: row.sort_order }
      this.dialogVisible = true
    },
    async saveCategory() {
      try {
        if (this.isEdit) {
          await adminApi.updateCategory(this.editId, this.form)
          this.$message.success('分类更新成功')
        } else {
          await adminApi.createCategory(this.form)
          this.$message.success('分类创建成功')
        }
        this.dialogVisible = false
        this.loadCategories()
      } catch (e) {
        this.$message.error('操作失败')
      }
    },
    async deleteCategory(row) {
      try {
        await this.$confirm(`确定删除分类「${row.name}」？`, '确认', { type: 'warning' })
        await adminApi.deleteCategory(row.id)
        this.$message.success('删除成功')
        this.loadCategories()
      } catch (e) {
        if (e !== 'cancel') this.$message.error('删除失败')
      }
    }
  }
}
</script>

<style scoped>
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.page-title {
  font-size: 22px;
  font-weight: 600;
  color: #2c3e50;
}
</style>
